import { render, staticRenderFns } from "./DataListOverview.vue?vue&type=template&id=43295550&"
import script from "./DataListOverview.vue?vue&type=script&lang=js&"
export * from "./DataListOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports